/* unplugin-vue-components disabled */import script from "./PosterSearchDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./PosterSearchDescription.vue?vue&type=script&setup=true&lang=js"

import "./PosterSearchDescription.vue?vue&type=style&index=0&id=e80c0cdc&scoped=true&lang=scss"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e80c0cdc"]])

export default __exports__